import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate'

import { alert } from './alert.module';
import { account } from './account.module';
import { global } from './global.module';

import users from '@/pages/Users/module';
import settings from '@/pages/Settings/module';
//#region Imports
import companies from '@/pages/Companies/module';
import aes_envelopes from '@/pages/Aes_envelopes/module';
import companylocations from '@/pages/Companylocations/module';
import aes_envelopestats from '@/pages/Aes_envelopestats/module';
import envelopestatuses from '@/pages/Envelopestatuses/module';
import businesses from '@/pages/Businesses/module';
import attributes from '@/pages/Attributes/module';
import contacts from '@/pages/Companycontacts/module';
import documents from '@/pages/Companydocuments/module';
import files from '@/pages/Companyfiles/module';
import brandName from '@/pages/DrugDatabase/BrandName/module'
import ndcDetails from '@/pages/DrugDatabase/NDC/module'
import cases from '@/pages/Cases/module';

//#endregion Imports

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    alert,
    account,
    users,
    settings,
    global,
    //#region Modules
    companies,
    cases,
    aes_envelopes,
    companylocations,
    aes_envelopestats,
    envelopestatuses,
    businesses,
    attributes,
    contacts,
    documents,
    files,
    brandName,
    ndcDetails
    //#endregion Modules
  },
  plugins: [
    // Session Local Storage
    // Will be deleted at end of session
    // Be careful of storing sensitive info!
    createPersistedState({
      paths: [
        'alert',
        'account',
        'users',
        'settings',
        //#region Paths
        'companies',
        'cases',
        'aes_envelopes',
        'companylocations',
        'aes_envelopestats',
        'envelopestatuses',
        'businesses',
        'attributes',
        'contacts',
        'documents',
        'files',
        'DrugDatabase'
        //#endregion Paths
      ],
      storage: sessionStorage
    }),
    // Permanent Local Storage
    // Use wisely - no sensitive info!
    createPersistedState({
      paths: [
      ],
      storage: localStorage
    }),
  ]
});

export default store;
